import { useEffect } from 'react';

interface UseDublicateClientsSettingsEffectsProps {
  getDublicateClientsSettings(): Promise<void>;
}

export const useDublicateClientsSettingsEffects = ({
  getDublicateClientsSettings,
}: UseDublicateClientsSettingsEffectsProps) => {
  useEffect(() => {
    getDublicateClientsSettings();
  }, [getDublicateClientsSettings]);
};
